import { put } from 'api';

export const getReportings = ({ params }) => {
  const { closestCommonParent, collectionPointIds, ...cleanedParams } = params;
  return put('/v1/extranet/reportings', {
    ...cleanedParams,
    selectedCollectionPointIds: collectionPointIds,
    fused: true // Default to true for the reporting endpoint
  });
};

const getCSV = (endpoint, params) => {
  const { closestCommonParent, collectionPointIds, ...cleanedParams } = params;
  return put(`v1/extranet/reportings/${endpoint}`, {
    ...cleanedParams,
    selectedCollectionPointIds: collectionPointIds,
    filename: cleanedParams.filename || (cleanedParams.fused? `${endpoint}.csv` : `${endpoint}.zip`)
  }, {
    headers: { 
      Accept: cleanedParams.fused ? 'text/csv' : 'application/zip',
    },
    responseType: cleanedParams.fused ? 'text/csv' : 'arraybuffer'
  });
};

export const getWasteRegisterCSV = params => getCSV('waste_register', params);

export const getCollectedResourcesCSV = params =>
  getCSV('collected_resources', params);

export const getWorkOrdersCSV = params => getCSV('work_orders', params);

export const getWeeklyWorkOrdersCSV = params => getCSV('weekly_work_orders', params);

export const getPastCollectionsCSV = params => getCSV('past_collections', params);
